module.exports = __webpack_public_path__ + "static/media/2.266b70d2.svg";